import React, { useContext } from 'react';
import { Input } from 'antd';
import classNames from 'classnames';
import InputAreaContext from './context';
import { SelectorMode } from '../UserSelection/types';
var TextArea = Input.TextArea;
export default function InputArea(_a) {
    var extraInputValue = _a.extraInputValue, despInputValue = _a.despInputValue, leaveWordInputValue = _a.leaveWordInputValue, strangerLeaveWordInputValue = _a.strangerLeaveWordInputValue, onInputExtraChange = _a.onInputExtraChange, onInputDespChange = _a.onInputDespChange, onInputLeaveWordChange = _a.onInputLeaveWordChange, onInputStrangerLeaveWordChange = _a.onInputStrangerLeaveWordChange;
    var _b = useContext(InputAreaContext), despInput = _b.despInput, extraInput = _b.extraInput, leaveWordInput = _b.leaveWordInput, strangerLeaveWordInput = _b.strangerLeaveWordInput, overlayClassName = _b.overlayClassName;
    var newMode = React.useContext(InputAreaContext).newMode;
    var inputComp = null;
    if (extraInput) {
        inputComp = (React.createElement("div", { className: "extra-input", style: {
                marginTop: 5,
                marginBottom: 10,
            } }, extraInput.isTextArea ? (React.createElement(TextArea, { spellCheck: "false", placeholder: extraInput.placeholder, maxLength: extraInput.maxLength, value: extraInputValue, autoSize: { minRows: 1, maxRows: 2 }, onChange: function (e) {
                onInputExtraChange === null || onInputExtraChange === void 0 ? void 0 : onInputExtraChange(e.target.value);
            } })) : (React.createElement(Input, { placeholder: extraInput.placeholder, maxLength: extraInput.maxLength, value: extraInputValue, onChange: function (e) {
                onInputExtraChange(e.target.value);
            } }))));
    }
    var inputDespComp = null;
    if (despInput) {
        inputDespComp = (React.createElement("div", { className: "desp-input", style: {
                marginTop: 5,
                marginBottom: 10,
            } }, despInput.isTextArea ? (React.createElement(TextArea, { placeholder: despInput.placeholder, maxLength: despInput.maxLength, value: despInputValue, autoSize: { minRows: 1, maxRows: 2 }, onChange: function (e) {
                onInputDespChange(e.target.value);
            } })) : (React.createElement(Input, { placeholder: despInput.placeholder, maxLength: despInput.maxLength, value: despInputValue, onChange: function (e) {
                onInputDespChange(e.target.value);
            } }))));
    }
    var inputLeaveWordComp = null;
    if (leaveWordInput) {
        inputLeaveWordComp = (React.createElement("div", { className: "leave-word-input", style: {
                marginTop: 5,
                marginBottom: 10,
            } }, leaveWordInput.isTextArea ? (React.createElement(TextArea, { placeholder: leaveWordInput.placeholder, maxLength: leaveWordInput.maxLength, value: leaveWordInputValue, autoSize: { minRows: 1, maxRows: 2 }, onChange: function (e) {
                onInputLeaveWordChange(e.target.value);
            } })) : (React.createElement(Input, { placeholder: leaveWordInput.placeholder, maxLength: leaveWordInput.maxLength, value: leaveWordInputValue, onChange: function (e) {
                onInputLeaveWordChange(e.target.value);
            } }))));
    }
    var strangerInputComp = null;
    if (strangerLeaveWordInput) {
        strangerInputComp = (React.createElement("div", { className: "leave-word-input", style: {
                marginTop: 5,
                marginBottom: 10,
            } },
            React.createElement(TextArea, { spellCheck: "false", value: strangerLeaveWordInputValue, maxLength: strangerLeaveWordInput.maxLength, autoSize: { minRows: 1, maxRows: 2 }, onChange: function (e) {
                    onInputStrangerLeaveWordChange(e.target.value);
                } })));
    }
    return (React.createElement("div", { className: classNames('input-container', overlayClassName, newMode === SelectorMode.stranger ? 'strange-input-container' : '') },
        inputComp,
        inputDespComp,
        inputLeaveWordComp,
        strangerInputComp));
}
//# sourceMappingURL=InputArea.js.map